import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { MOEDA_PADRAO, formatCurrency as formatarMoeda } from '@/lib/format';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts a hex color string to HSL format string "H S% L%".
 * Accepts 3-digit (#RGB) or 6-digit (#RRGGBB) hex, with or without #.
 */
export function hexToHsl(hex: string): string {
  // Remove # prefix if present
  hex = hex.replace(/^#/, '');

  // Expand 3-digit hex to 6-digit
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  const r = Number.parseInt(hex.slice(0, 2), 16) / 255;
  const g = Number.parseInt(hex.slice(2, 4), 16) / 255;
  const b = Number.parseInt(hex.slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;

  if (max === min) {
    return `0 0% ${Math.round(l * 100)}%`;
  }

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

  let h: number;
  switch (max) {
    case r:
      h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
      break;
    case g:
      h = ((b - r) / d + 2) / 6;
      break;
    default:
      h = ((r - g) / d + 4) / 6;
      break;
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

/**
 * Mantido por compatibilidade com os chamadores antigos. O padrao do `locale`
 * deixou de ser fixo: sem argumento, a forma acompanha o idioma ativo (a moeda
 * nao — ver `@/lib/format`). Codigo novo importa de `@/lib/format` direto.
 */
export function formatCurrency(value: number, currency = MOEDA_PADRAO, locale?: string): string {
  return formatarMoeda(value, { currency, locale });
}
